import script from "./FadeSettingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FadeSettingPage.vue?vue&type=script&setup=true&lang=js"

import "./FadeSettingPage.vue?vue&type=style&index=0&id=f5dc4f24&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5dc4f24"]])

export default __exports__